const { SOCKET_URL } = require('../../core/constants/urls')

const CoinImg = ({ id, size = 24, ...rest }) => {
	return (
		<img
			src={
				id === 'irt'
					? require('../../assets/images/tooman.png')
					: SOCKET_URL + `assets/icon/${id}.png`
			}
			alt={id}
			width={size}
			height={size}
			{...rest}
		/>
	)
}

export default CoinImg
